import Component from 'vue-class-component';
import FormatService from '../services/FormatService';
import FormatVersionService from '../services/FormatVersionService';
import FormatParameterService from '../services/FormatParameterService';
import ComponentBase from './ComponentBase';
import { IFormat, Format } from '../../../adnami_ts_models/app';
import { AxiosPromise } from 'axios';


@Component
export default class FormatsBase extends ComponentBase {
    editUrl: string = "/editformat/";
    createUrl: string = "/createformat/";
    listUrl: string = "/listformats/";

    formatService = FormatService;
    formatVersionService = FormatVersionService;
    formatParametersService = FormatParameterService;

    formats: IFormat[] = [];

    redirectToCreateFormat(id: string = null) {
        const url = id ? `${this.createUrl}?formatId=${id}` : this.createUrl;
        // @ts-ignore
        this.$router.push(url);
    }

    redirectToEditFormat(id: string) {
        if (id !== null && id !== "") {
            // @ts-ignore
            this.$router.push(`${this.editUrl}?formatId=${id}`);
        }
        else {
            throw new Error("Format title missing");
        }
    }

    redirectToFormatList() {
        // @ts-ignore
        this.$router.push(this.listUrl);
    }

    isCreateFormatPage() {
        // @ts-ignore
        return this.$router.currentRoute.path.indexOf(this.createUrl) !== -1;
    }

    isEditFormatPage() {
        // @ts-ignore
        return this.$router.currentRoute.path.indexOf(this.editUrl) !== -1;
    }
    async fetchFormats(): Promise<IFormat[]> {
        try {
            let response = await this.formatService.getFormats();
            if (response.status !== 200) {
                this.notification.Error("Could not fetch formats. Reload page and try again.");
                console.error("Getting invaid status code while fetching formats", response);
            }
            return response && response.data || [];
        } catch (ex) {
            this.notification.Error("Could not fetch formats. Reload page and try again.");
            console.error("Error while fetching formats", ex);
        }

        return [];
    }

    async init() {
        this.formats = await this.fetchFormats();
    }
}
